// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eccd2e07","732":"91d80f6f","977":"9c25f6f4"}[chunkId] + ".chunk.js";
};